// eslint-disable-next-line no-shadow
enum EventMoneyTransferStatus {
  WAITING,
  TRANSFERRED,
  REFUSED,
}
export default EventMoneyTransferStatus;
